import { render, staticRenderFns } from "./setActivityTwo.vue?vue&type=template&id=9e060b1a&scoped=true&"
import script from "./setActivityTwo.vue?vue&type=script&lang=js&"
export * from "./setActivityTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e060b1a",
  null
  
)

export default component.exports